import { HttpService } from '@Services/index.ts';
import { useBoundStore } from '@Store/index.ts';
import { InstitutionIds } from '@Types/types.ts';
import { ICreateLeadResponse } from './partnerWelcome.api';

export interface ICreateLeadPayload {
  firstName?: string;
  lastName?: string;
  email: string;
  password: string;
}

export const createLead = async (payload: ICreateLeadPayload) => {
  const { adSource, referralCode } = useBoundStore.getState().onboardingSlice;
  try {
    const { data } = await HttpService.put('v3/onboarding/customer/', {
      firstName: payload.firstName || null,
      lastName: payload.lastName || null,
      email: payload.email,
      password: payload.password,
      bankCode: InstitutionIds.SUNRISE,
      fingerprint: (window as unknown as { fpId: string }).fpId,
      referralCode,
      adSource,
      abTestNames: [],
    });

    return data as ICreateLeadResponse;
  } catch (error: unknown) {
    console.log(error);
  }
};
